import { useEffect, useRef, useState } from "react";
import BaseDialog from "../../modelDialogs/BaseDialog";
import { formatDateTime } from "../../models/utils";
import { itx } from "../../translationItx/itx";
import ProjectMetadata from "../../models/ProjectMetadata";
import { loadProject } from "../LoadProject";
import universalstorageHandler from "../../persistence/UniversalstorageHandler";
import compareProjects from "../../CompareProjects";
import { showErrToast, showToast, updateToastProgress } from "../Toasts";
import Logger from "../../Logger";
import WaitDialog from "../WaitDialog";
import { ApplicationMode } from "../../models/SettingsEnums";

const logger = new Logger();

export default function SelectSnapshotDiaog(props: { projectMetadata: ProjectMetadata; navigate: any }) {
  const { projectMetadata, navigate } = props;
  const [availiableBackups, setAvailiableBackups] = useState(projectMetadata.snapshots);
  const [selectedSnapshotId, setSnapshotId] = useState<string>("");
  const hasSelectedBackup = availiableBackups.some((backup) => backup.id === selectedSnapshotId);
  useEffect(() => {
    // load snapshots ?
    fetchProjects();
  }, []);

  async function fetchProjects() {
    const projectList = await universalstorageHandler.localStorageHandler.loadProjectList(state.loggedInUser.email);

    //const sUser = localStorage.getItem("user");

    // if (sUser && sUser != "") {
    //   const user = JSON.parse(sUser);
    //   const email = user.email;

    // const res = await universalstorageHandler.loadProjectList(email);
    try {
      logger.log(`projects loaded ${projectList.length}`);

      const allSnapshotsOfProjectArray = new Array<ProjectMetadata>();
      projectList.forEach((data: any) => {
        // handle here snapshots

        if (data.id.includes("-snapshot") && data.id.startsWith(projectMetadata.id)) {
          const metadata = new ProjectMetadata();
          metadata.fromJSON(data);
          allSnapshotsOfProjectArray.push(metadata);
        }
      });
      if (allSnapshotsOfProjectArray.length > 0) {
        setAvailiableBackups(allSnapshotsOfProjectArray);
      }
    } catch (ex) {
      logger.error(ex);
    }
    //}
  }

  function SnapshotDropdown(props: {}) {
    let snapshotOptions = new Array<any>();

    snapshotOptions.push(
      <option value={projectMetadata.id}>{itx("SelectSnapshotDiaog.selectSnapshot", "Backup auswählen")}</option>,
    );
    const sortedBackups = [...availiableBackups].sort((left, right) => {
      const leftTime = left.localCopied?.getTime() || 0;
      const rightTime = right.localCopied?.getTime() || 0;
      return rightTime - leftTime;
    });

    sortedBackups.forEach((snapshot) => {
      const isAutobackup = snapshot.id.includes("-snapshot-autobackup-");
      const typeLabel = isAutobackup
        ? itx("SelectSnapshotDiaog.autobackup", "Autobackup")
        : itx("SelectSnapshotDiaog.backupOnSave", "Backup (beim Speichern)");
      snapshotOptions.push(
        <option key={snapshot.id} value={snapshot.id}>
          {formatDateTime(snapshot.localCopied)} – {typeLabel}
        </option>,
      );
    });
    if (availiableBackups.length > 0) {
      return (
        <select
          className="select"
          id={`ParentSelection_${projectMetadata.id}`}
          defaultValue={projectMetadata.id}
          value={selectedSnapshotId}
          onChange={(ev) => {
            ev.stopPropagation();
            setSnapshotId(ev.target.value);
          }}
          onClick={(ev) => {
            ev.stopPropagation();
          }}
          style={{ marginBottom: "20px" }}
        >
          {snapshotOptions}
        </select>
      );
    } else {
      return (
        <div style={{ color: "grey" }}>{itx("SelectSnapshotDiaog.noBackupAvailiable", "Kein Backup vorhanden")}</div>
      );
    }
  }
  async function clickOpenProject() {
    ////////////////////////////////////////////////
    // bis jetzt immeer fehlermeldung, da das projekt keine items hat?????????????????????????????
    ////////////////////////////////////////////////////////
    let selectedMethadata = projectMetadata;
    availiableBackups.forEach((backup) => {
      if (backup.id == selectedSnapshotId) {
        selectedMethadata = backup;
      }
    });
    if (selectedMethadata.id != selectedSnapshotId) {
      showErrToast(itx("SelectSnapshotDiaog.noSnapshotSelected", "Kein Backup ausgewählt"));
      return;
    }

    let blob: Blob | undefined = undefined;
    if (selectedMethadata?.className != "ProjectMetadata") {
      console.error("Snapchat no methadata " + selectedMethadata.id);
      return;
    }

    //
    // Hier kommen wir online und offline an,
    //    wenn das Project nicht gemerged werden muß

    let loadLocal = true;

    blob = await loadProject(selectedMethadata.id, loadLocal);

    // START PROJECT COMPARISON IF window.compareState exists.
    if (window.compareState) {
      compareProjects(window.state, window.compareState);
    }

    //
    // hide loading toast
    //
    updateToastProgress({ progress: 100 });

    logger.log(`loadProject ${selectedMethadata.id} ${blob}`);
    if (blob) {
      const targetPath = selectedMethadata.applicationMode === ApplicationMode.ConceptOne ? "/concept-one" : "/app";
      navigate(targetPath);
      // state.navigate("/app");// cant be usd becaus navigate in state is undefined
    }
  }
  const moreButtons = new Array<any>();

  moreButtons.push(
    <button
      className="button"
      disabled={!hasSelectedBackup}
      onClick={async () => {
        // download selected snapshot as .estada file
        if (selectedSnapshotId != "") {
          let selectedMethadata = projectMetadata;
          availiableBackups.forEach((backup) => {
            if (backup.id == selectedSnapshotId) {
              selectedMethadata = backup;
            }
          });
          if (selectedMethadata.id != selectedSnapshotId) {
            showErrToast(itx("SelectSnapshotDiaog.noSnapshotSelected", "Kein Backup ausgewählt"));
            return;
          }
          try {
            // Snapshots are stored locally only — read the raw zip blob directly
            // from IndexedDB without going through the (potentially server-side) storageHandler
            state.dialogManager.openDialog(
              <WaitDialog
                title={itx("SelectSnapshotDiaog.downloading", "Backup wird heruntergeladen...")}
                text={itx("SelectSnapshotDiaog.downloadingDescription", "..könnte eine Weile dauern")}
              ></WaitDialog>,
            );
            const blob = await universalstorageHandler.localStorageHandler.loadProjectItems(selectedMethadata.id);
            if (!blob) {
              state.dialogManager.closeDialog();
              showErrToast(itx("SelectSnapshotDiaog.backupNotFound", "Backup-Datei nicht gefunden"));
              return;
            }
            const dateStr = formatDateTime(selectedMethadata.localCopied).replace(/[:/,\s]+/g, "_");
            const fileName = `${projectMetadata.name}_backup_${dateStr}.estada`;
            const elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = fileName;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
            state.dialogManager.closeDialog(); // close loading dialog
            showToast({
              text: itx("homePage.projectDownloaded", `Backup T1 wurde auf Ihren Rechner herunter geladen`, {
                T1: fileName,
              }),
            });
          } catch (ex) {
            state.dialogManager.closeDialog(); // close loading dialog
            logger.error(ex);
          }
          state.dialogManager.closeDialog();
        } else {
          showErrToast(itx("SelectSnapshotDiaog.noSnapshotSelected", "Kein Backup ausgewählt"));
        }
      }}
    >
      {itx("SelectSnapshotDiaog.downloadEstdaData", "Lokal herunterladen")}
    </button>,
  );

  return (
    <BaseDialog
      title={itx("SelectSnapshotDiaog.loadBackup", "Backup laden")}
      okCaption={itx("SelectSnapshotDiaog.openSnapshot", "Backup öffnen")}
      okDisabled={!hasSelectedBackup}
      enterAsOk={hasSelectedBackup}
      onClose={() => {
        return true;
      }}
      onOk={() => {
        // open snapshot
        if (selectedSnapshotId != "") {
          clickOpenProject();
          return true;
        } else {
          return false;
        }
      }}
      moreButtons={moreButtons}
      hideXButton={true}
    >
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        {itx("SelectSnapshotDiaog.question", "Wähle das gewünschte Backup aus.")}
        <br />
        <br />
        <SnapshotDropdown />
        <div style={{ fontSize: "10px" }}>
          {itx("SelectSnapshotDiaog.onlyLocal", "Backups sind nur lokal verfügbar")}
        </div>
      </div>
    </BaseDialog>
  );
}
